import React from 'react'
import { RemoteErrorBoundary, isInExoSkeleton } from '@adsk/napi-exo-client'
import ErrorBoundary from '@adsk/napi-error-boundary'
import { BugsnagNotify } from '@adsk/napi-bugsnag'

interface ConditionalErrorBoundaryProps {
	children: React.JSX.Element
	componentName: string
	componentVersion: string
	isFetchFailure?: boolean
	ErrorModal: React.FC<ErrorModalProps>
}
interface ErrorModalProps {
	isFetchFailure?: boolean
}
export const ConditionalErrorBoundary: React.FC<
	ConditionalErrorBoundaryProps
> = ({
	children,
	componentName,
	componentVersion,
	isFetchFailure = false,
	ErrorModal,
}: ConditionalErrorBoundaryProps) => {
	const isInExo = isInExoSkeleton()
	if (isInExo) {
		console.log('Will be invoking the RemoteErrorBoundary component')
		return (
			<RemoteErrorBoundary
				FallbackComponent={() => <ErrorModal isFetchFailure={isFetchFailure} />}
				reportErrorContext={{ componentName, componentVersion }}
				onError={(error: Error) => {
					console.log('Notified via RemoteErrorBoundary Bugsnag')
					BugsnagNotify(error, {
						message: error.message,
					})
				}}
			>
				{children}
			</RemoteErrorBoundary>
		)
	} else {
		return (
			<ErrorBoundary
				data-testid="error-boundary"
				FallbackComponent={<ErrorModal isFetchFailure={isFetchFailure} />}
				componentName={componentName}
				componentVersion={componentVersion}
			>
				{children}
			</ErrorBoundary>
		)
	}
}
